import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Divider, Dropdown, Modal, Space, theme } from 'antd'
import { useNavigate } from 'react-router-dom'
import { BrowserView } from 'react-device-detect'
import { signOut } from 'firebase/auth'

import { generateContent } from '../../../../setup'
import { firebaseAuth } from '../../../..'
import { handleError } from '../../../lib/utils'
import Router from '../router'
import AuthEnums from '../../utils/enums'
import CoreReducer from '../../../../core/utils/reducer'
import CoreEnums from '../../../../core/utils/enums'
import authReducer from '../../utils/reducer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import ProfileEnums from '../../../Profile/utils/enums'
import FullscreenButton from '../../../reusable-components/FullscreenButton'
import { warnUnsavedChanges } from '../../../../core/utils/utils'

const ToolbarCustomMenus = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const coreState = useSelector((state) => state.core)
  const [image, setImage] = useState()
  const state = useSelector((state) => state.auth)
  const { token } = theme.useToken()

  const handleLogin = () => {
    navigate(AuthEnums.routes.LOGIN)
  }

  const handleSignup = () => {
    navigate(AuthEnums.routes.REGISTER)
  }

  const handleSignOut = async () => {
    try {
      await signOut(firebaseAuth)
      // dispatch(CoreReducer.actions.resetTabs()) This is no longer needed and is causing signout to break
      dispatch(CoreReducer.actions.resetState())
      dispatch(CoreReducer.actions.enableDisableLeftMenu(false))
      dispatch(CoreReducer.actions.enableDisableRightMenu(false))
      dispatch(CoreReducer.actions.enableDisableTabs(false))
      dispatch(CoreReducer.actions.setRootContent(Router))
      dispatch(authReducer.actions.setUser(null))
      dispatch(authReducer.actions.setAgiliteUser(null))
      dispatch(authReducer.actions.setLoggedIn(false))
    } catch (e) {
      handleError(e, true)
    }
  }

  // const generateUserType = () => {
  //   let text = ''

  //   if (state.agiliteUser) {
  //     if (state.agiliteUser.extraData.role.type === 'medical_professional') {
  //       text = <span style={{ textTransform: 'capitalize' }}>{state.agiliteUser.extraData.profession}</span>
  //     } else if (state.agiliteUser.extraData.role.type === 'admin') {
  //       text = 'Admin'
  //     } else if (state.agiliteUser.extraData.role.type === 'reception') {
  //       text = 'Reception'
  //     }
  //   }

  //   return text
  // }

  const handleDropDownItemsOnClickEvent = (key) => {
    if (warnUnsavedChanges()) {
      Modal.confirm({
        title: 'Careful, you have unsaved changes!',
        content: 'Are you sure you want to leave this page? You have unsaved changes.',
        okText: 'Leave Anyway',
        okButtonProps: { style: { background: token.colorError, color: 'white' } },
        cancelText: 'No, take me back',
        onOk: () => {
          dispatch(CoreReducer.actions.addTab(generateContent(key)))
        }
      })
    } else {
      dispatch(CoreReducer.actions.addTab(generateContent(key)))
    }
  }

  const handleGetItems = () => {
    const dropDownItems = {
      loggedInUser: {
        key: 'loggedInUser',
        label: (
          <div style={{ marginBottom: 10 }}>
            <span style={{ fontSize: 12, color: '#ccc' }}>
              {state.agiliteUser?.firstName + ' ' + state.agiliteUser?.lastName}
            </span>
          </div>
        ),
        onClick: () => {},
        type: 'group'
      },
      personalDetails: {
        key: CoreEnums.tabKeys.PERSONAL_DETAILS,
        label: CoreEnums.tabTitles.PERSONAL_DETAILS,
        onClick: () => {
          handleDropDownItemsOnClickEvent(CoreEnums.tabKeys.PERSONAL_DETAILS)
        }
      },
      management: {
        key: CoreEnums.tabTitles.MANAGEMENT,
        label: CoreEnums.tabTitles.MANAGEMENT,
        onClick: () => {
          handleDropDownItemsOnClickEvent(CoreEnums.tabKeys.MANAGEMENT)
        }
      },
      availability: {
        key: CoreEnums.tabTitles.AVAILABILITY,
        label: CoreEnums.tabTitles.AVAILABILITY,
        onClick: () => {
          handleDropDownItemsOnClickEvent(CoreEnums.tabKeys.AVAILABILITY)
        }
      },
      signOut: {
        danger: true,
        key: CoreEnums.tabKeys.SIGN_OUT,
        label: CoreEnums.tabTitles.SIGN_OUT,
        disabled: coreState.signOutDisabled,
        onClick: () => {
          Modal.confirm({
            title: warnUnsavedChanges() ? 'Careful, you have unsaved changes!' : 'Confirmation',
            content: warnUnsavedChanges()
              ? `Are you sure you want to Sign Out of the ${coreState?.entity?.name} Portal? You have unsaved changes.`
              : `Are you sure you want to Sign Out of the ${coreState?.entity?.name} Portal`,
            onOk: () => handleSignOut(),
            okButtonProps: {
              style: { background: warnUnsavedChanges() ? token.colorError : token.colorSuccess, color: 'white' }
            },
            okText: 'Sign Out',
            cancelText: warnUnsavedChanges() ? 'No, take me back' : 'Cancel',
            className: token.themeControl
          })
        }
      },
      medicalHistory: {
        key: CoreEnums.tabKeys.MEDICAL_HISTORY,
        label: CoreEnums.tabTitles.MEDICAL_HISTORY,
        onClick: () => {
          handleDropDownItemsOnClickEvent(CoreEnums.tabKeys.MEDICAL_HISTORY)
        }
      },
      dependants: {
        key: CoreEnums.tabKeys.DEPENDANTS,
        label: CoreEnums.tabTitles.DEPENDANTS,
        onClick: () => {
          handleDropDownItemsOnClickEvent(CoreEnums.tabKeys.DEPENDANTS)
        }
      },
      version: {
        key: 'version',
        label: <small style={{ color: '#ccc' }}>Version {process.env.REACT_APP_VERSION}</small>,
        type: 'group'
      }
    }

    if (
      state.agiliteUser?.extraData?.role.type === 'medical_professional' &&
      state.agiliteUser?.extraData?.role.isManager === false
    ) {
      return [
        dropDownItems.loggedInUser,
        dropDownItems.availability,
        dropDownItems.personalDetails,
        dropDownItems.signOut,
        dropDownItems.version
      ]
    }

    if (
      state.agiliteUser?.extraData?.role.type === 'medical_professional' &&
      state.agiliteUser?.extraData?.role.isManager === true
    ) {
      return [
        dropDownItems.loggedInUser,
        dropDownItems.management,
        dropDownItems.availability,
        dropDownItems.personalDetails,
        dropDownItems.signOut,
        dropDownItems.version
      ]
    }

    if (state.agiliteUser?.extraData?.role.type !== 'patient') {
      return [dropDownItems.loggedInUser, dropDownItems.personalDetails, dropDownItems.signOut, dropDownItems.version]
    } else {
      return [
        dropDownItems.loggedInUser,
        dropDownItems.personalDetails,
        // dropDownItems.medicalHistory,
        // dropDownItems.dependants,
        dropDownItems.signOut,
        dropDownItems.version
      ]
    }
  }

  useEffect(() => {
    handleGetImage()
    // eslint-disable-next-line
  }, [state.agiliteUser])

  const handleGetImage = () => {
    const userData = state.agiliteUser

    let tmpImage = null

    if (userData?.profileImage) {
      tmpImage = userData.profileImage
    } else if (firebaseAuth?.currentUser?.photoURL) {
      tmpImage = firebaseAuth.currentUser.photoURL
    } else {
      tmpImage = ProfileEnums.images.DEFAULT_IMAGE
    }

    setImage(tmpImage)
  }

  const authState = useSelector((state) => state.auth)

  return (
    <>
      {state.loggedIn ? (
        <>
          <FullscreenButton
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: 'white',
              marginRight: '8px'
            }}
          />
          <Dropdown
            style={{ border: '1px red solid' }}
            trigger={['hover']}
            menu={{
              items: handleGetItems()
            }}
          >
            <Space wrap style={{ cursor: 'pointer' }}>
              <FontAwesomeIcon style={{ color: 'white', cursor: 'pointer' }} icon={faChevronDown} />
              <div
                style={{
                  width: 32,
                  height: 32,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  border: '1px rgba(255,255,255, 0.2) solid'
                }}
              >
                <img style={{ width: '100%', display: 'block' }} src={image} alt='Profile' />
              </div>
            </Space>
          </Dropdown>
        </>
      ) : (
        <>
          {/* <Divider type='vertical' /> */}
          <BrowserView>
            <span style={{ fontSize: 14 }}>ALREADY A MEMBER?</span>
          </BrowserView>
          <Button
            style={{ backgroundColor: token.colorPrimary, border: '1px solid white' }}
            type='primary'
            onClick={handleLogin}
          >
            Sign In
          </Button>
          <Divider type='vertical' />
          <Button
            style={{ backgroundColor: token.colorPrimary, border: 'none', color: token.colorWhite, padding: 0 }}
            onClick={handleSignup}
          >
            Register
          </Button>
        </>
      )}
    </>
  )
}

export default ToolbarCustomMenus
